import React from 'react';
import { useSelector } from "react-redux";
import {
  CRow,
  CFormGroup,
  CCol,
  CInputRadio,
  CLabel,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput,
} from "@coreui/react";

const Basic = (props) => {
  const { handleInputChange } = props;
  const { insert } = useSelector((state) => state);

  return (
    <>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>이름
          </CLabel>
          <CInput
            type="text"
            id="name"
            name="name"
            defaultValue={insert.reqTaskInfo.name || ""}
            disabled
          />
        </CCol>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>휴대전화번호
          </CLabel>
          <CInput
            type="text"
            id="hphnNo"
            name="hphnNo"
            defaultValue={insert.reqTaskInfo.hphnNo || ""}
            disabled
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol xs="12" className="text-left">
          <CLabel>
            <span>*</span>주민등록번호
          </CLabel>
        </CCol>
        <CCol xs="5" className="mb-2 notPaddingRight">
          <CInput
            type="text"
            id="resRegNoFront"
            name="resRegNoFront"
            value={insert.reqTaskInfo.resRegNoFront || ""}
            maxLength="6"
            disabled
          />
        </CCol>
        <CCol xs="7" className="mb-2 notPaddingLeft">
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText className="prependText">-</CInputGroupText>
            </CInputGroupPrepend>
            <CInput
              type="text"
              id="resRegNoBack"
              name="resRegNoBack"
              placeholder="뒤 7자리"
              value={insert.reqTaskInfo.resRegNoBack || ""}
              maxLength="7"
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CInputGroup>
        </CCol>
      </CRow>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>생년월일
          </CLabel>
          <CInput
            type="date"
            id="bdt"
            name="bdt"
            value={insert.reqTaskInfo.bdt || ""}
            max="9999-12-31"
            disabled
          />
        </CCol>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>성별
          </CLabel>
          <CCol>
            <CFormGroup variant="custom-radio" inline>
              <CInputRadio
                custom
                id="sexM"
                name="sex"
                value="M"
                checked={
                  insert.reqTaskInfo.sex === "M" ? true : false
                }
                readOnly
              />
              <CLabel variant="custom-checkbox" htmlFor="sexM">
                남자
              </CLabel>
            </CFormGroup>
            <CFormGroup variant="custom-radio" inline>
              <CInputRadio
                custom
                id="sexF"
                name="sex"
                value="F"
                checked={
                  insert.reqTaskInfo.sex === "F" ? true : false
                }
                readOnly
              />
              <CLabel variant="custom-checkbox" htmlFor="sexF">
                여자
              </CLabel>
            </CFormGroup>
          </CCol>
        </CCol>
      </CRow>
    </>
  )
}

export default React.memo(Basic);